import { Routes, Route } from "react-router-dom";
import { GamificationList } from "./list";
import { CreateGamification } from "./create";
import { EditGamification } from "./edit";

export default function GamificationRoutes() {
  return (
    <Routes>
      <Route path="/" element={<GamificationList />} />
      <Route path="/criar" element={<CreateGamification />} />
      <Route path="/editar/:id" element={<EditGamification />} />
    </Routes>
  );
}
